import React, { useState, useEffect, useRef } from "react";
import exelIcon from "../../../../../assets/ms_excel.png";
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next'
import {
    fetchExternalParticipants,
    sendRemeinder,
    updateParticipantStatus,
    updateMapAccess
} from "../../../store/Conference/ConferenceThunks.js";
import { setConferenceParticipants } from "../../../store/Conference/CreateConferenceSlice.js";
import * as XLSX from "xlsx";
import "./GeustConferenceManagment.css";
import { FIRE_GUEST } from "../../../../Map/store/Avatars/AvatarsSlice.js";

export default function GeustConferenceManagment() {
    const menuRef = useRef();
    const dispatch = useDispatch();

    const {
        conferenceParticipants
    } = useSelector((state) => state.createConference);

    const {
        initialReservation
    } = useSelector((state) => state.RoomMenu);

    const [count, setCount] = useState();
    const [search, setSearch] = useState("");
    const [selectedExternalParticipent, setSelectedExternalParticipent] = useState([]);
    const [selectAll, setSelectAll] = useState(false);

    const handleSelectAll = (e) => {
        const checked = e.target.checked;
        setSelectAll(checked);

        if (checked) {
            const allIds = conferenceParticipants.map(p => p.user_id);
            setSelectedExternalParticipent(allIds);
        } else {
            setSelectedExternalParticipent([]);
        }
    };

    const handleSelectOne = (id) => {
        setSelectedExternalParticipent(prev => {
            if (prev.includes(id)) {
                return prev.filter(item => item !== id);
            } else {
                return [...prev, id];
            }
        });
    };

    useEffect(() => {
        if (conferenceParticipants.length === 0) return;

        setSelectAll(
            selectedExternalParticipent.length === conferenceParticipants.length
        );
    }, [selectedExternalParticipent, conferenceParticipants]);

    const filteredParticipants = conferenceParticipants.filter(p => {
        const name = `${p.firstName || ""} ${p.lastName || ""}`.toLowerCase();
        const email = p.email?.toLowerCase() || "";

        return (
            name.includes(search.toLowerCase()) ||
            email.includes(search.toLowerCase())
        );
    });

    const { t } = useTranslation();

    const getStatusClass = status => {
        switch (status) {
            case "present":
                return "conf-badge badge-green";
            case "absent":
                return "conf-badge badge-orange";
            case "banni":
                return "conf-badge badge-red";
            case "awaiting_registration":
                return "conf-badge badge-gery";
            case "en_attend":
                return "conf-badge badge-gery";
            default:
                return "conf-badge";
        }
    };

    const loadParticipants = async () => {
        try {
            const res = await dispatch(
                fetchExternalParticipants({
                    params: [{ ConferenceId: initialReservation.id }]
                })
            );
            const participants = res?.payload.participants || [];
            const sortedParticipants = participants.sort(
                (a, b) => a.user_id - b.user_id
            );
            setCount(res.payload.counts);
            dispatch(setConferenceParticipants(sortedParticipants));
        } catch (error) {
            console.error("Erreur chargement participants:", error);
        }
    };


    useEffect(() => {
        if (!initialReservation?.id) return;
        loadParticipants();
    }, [initialReservation?.id]);

    const handleExportExcel = (e) => {
        e.preventDefault();
        const selectedUsers = conferenceParticipants.filter(p =>
            selectedExternalParticipent.includes(p.user_id)
        );

        if (selectedUsers.length === 0) {
            return;
        }

        // transformer data → format excel
        const data = selectedUsers.map(p => ({
            Nom: p.firstName || "Guest",
            Prénom: p.lastName || "",
            Email: p.email,
            Statut: p.conference_status,
            Accès: p.access_type,
            Inscription: p.inscription_date || "-"
        }));

        // créer fichier Excel
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheet, "Participants");

        // download
        XLSX.writeFile(workbook, "participants.xlsx");
    };

    const handleRelance = (e, user = null) => {
        e.preventDefault();
        if (!initialReservation?.id) return;
        const sendReminder = async () => {
            try {
                const res = await dispatch(
                    sendRemeinder({ body: { conferenceId: initialReservation?.id, users: user ? [user] : selectedExternalParticipent } })
                )

                handleClick();
            } catch (error) {
                console.error("Erreur chargement participants:", error);
            }
        };

        sendReminder();
    }

    const [menu, setMenu] = useState({
        open: false,
        x: 0,
        y: 0,
        userId: null
    })

    const handleOpenMenu = (e, userId) => {
        e.stopPropagation();
        const rect = e.currentTarget.getBoundingClientRect();
        let x = rect.right;
        let y = rect.bottom;
        if (window.innerWidth - x < 240) {
            x = rect.left - 220;
        }
        if (window.innerHeight - y < 150) {
            y = rect.top - 150;
        }
        setMenu({ open: true, x, y, userId });
    }

    const handleClick = () => {
        setMenu(prev => ({ ...prev, open: false }));
    };

    useEffect(() => {
        handleClick();

        document.addEventListener("click", handleClick);
        return () => document.removeEventListener("click", handleClick);
    }, []);

    const handleChangeStatus = (e, userId, newStatus) => {
        e.preventDefault();
        if (!initialReservation?.id) return;

        const participant = filteredParticipants?.find(
            p => p.user_id === userId
        );

        if (!participant) return;
        let statusToSend = newStatus;

        if (newStatus === "banni") {
            statusToSend = "banni";
        } else {
            if (participant.inscription_date === null) {
                statusToSend = "awaiting_registration";
            } else {
                const now = new Date();
                const eventDate = new Date(initialReservation.date);

                if (now >= eventDate) {
                    statusToSend = "en_attend";
                } else {
                    statusToSend = "absent";
                }
            }
        }
        const updateStatus = async () => {
            try {
                const res = await dispatch(
                    updateParticipantStatus(
                        {
                            body: {
                                conferenceId: initialReservation?.id,
                                email: participant.email,
                                status: statusToSend
                            }
                        }
                    )
                ).unwrap();
                if (res?.status === "banni" && res?.success === true) {

                    dispatch(FIRE_GUEST({
                        avatarEmail: participant?.email,
                    }))
                }
                loadParticipants();
                handleClick();
            } catch (error) {
                console.error("Erreur chargement participants:", error);
            }
        };

        updateStatus();
    }

    const handleChangeAccess = (e, userId) => {
        e.preventDefault();
        if (!initialReservation?.id) return;

        const participant = filteredParticipants?.find(
            p => p.user_id === userId
        );

        if (!participant) return;

        const updateAccess = async () => {
            try {
                const res = await dispatch(
                    updateMapAccess(
                        {
                            body: {
                                conferenceId: initialReservation?.id,
                                email: participant.email
                            }
                        }
                    )
                )
                loadParticipants();
                handleClick();
            } catch (error) {
                console.error("Erreur chargement participants:", error);
            }
        };
        updateAccess();
    }

    const formatDate = (isoDate) => {
        if (!isoDate) return ''
        const date = new Date(isoDate);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };


    return (
        <>
            <div className="container">
                <div className="stats">
                    <div className="conf-card">
                        <span className="icon-card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M13.3332 17.5V15.8333C13.3332 14.9493 12.982 14.1014 12.3569 13.4763C11.7317 12.8512 10.8839 12.5 9.99984 12.5H4.99984C4.11578 12.5 3.26794 12.8512 2.64281 13.4763C2.01769 14.1014 1.6665 14.9493 1.6665 15.8333V17.5" stroke="#469732" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M13.3335 2.60645C14.0483 2.79175 14.6813 3.20917 15.1332 3.79316C15.5851 4.37716 15.8303 5.09469 15.8303 5.83311C15.8303 6.57154 15.5851 7.28906 15.1332 7.87306C14.6813 8.45706 14.0483 8.87447 13.3335 9.05978" stroke="#469732" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M18.3335 17.5001V15.8334C18.3329 15.0948 18.0871 14.3774 17.6346 13.7937C17.1821 13.2099 16.5486 12.793 15.8335 12.6084" stroke="#469732" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M7.49984 9.16667C9.34079 9.16667 10.8332 7.67428 10.8332 5.83333C10.8332 3.99238 9.34079 2.5 7.49984 2.5C5.65889 2.5 4.1665 3.99238 4.1665 5.83333C4.1665 7.67428 5.65889 9.16667 7.49984 9.16667Z" stroke="#469732" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </span>
                        <span className="txt-card">
                            <span className="count-card">
                                {count?.subscribed}
                            </span>
                            Inscrit
                        </span>
                    </div>
                    <div className="conf-card card-green">
                        <span className="icon-card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M13.3335 9.16667L15.0002 10.8333L18.3335 7.5" stroke="#1FB356" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M13.3332 17.5V15.8333C13.3332 14.9493 12.982 14.1014 12.3569 13.4763C11.7317 12.8512 10.8839 12.5 9.99984 12.5H4.99984C4.11578 12.5 3.26794 12.8512 2.64281 13.4763C2.01769 14.1014 1.6665 14.9493 1.6665 15.8333V17.5" stroke="#1FB356" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M7.49984 9.16667C9.34079 9.16667 10.8332 7.67428 10.8332 5.83333C10.8332 3.99238 9.34079 2.5 7.49984 2.5C5.65889 2.5 4.1665 3.99238 4.1665 5.83333C4.1665 7.67428 5.65889 9.16667 7.49984 9.16667Z" stroke="#1FB356" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </span>
                        <span className="txt-card">
                            <span className="count-card">
                                {count?.present}
                            </span>
                            Présents
                        </span>
                    </div>
                    <div className="conf-card card-orange">
                        <span className="icon-card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M13.3332 17.5V15.8333C13.3332 14.9493 12.982 14.1014 12.3569 13.4763C11.7317 12.8512 10.8839 12.5 9.99984 12.5H4.99984C4.11578 12.5 3.26794 12.8512 2.64281 13.4763C2.01769 14.1014 1.6665 14.9493 1.6665 15.8333V17.5" stroke="#F79009" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M7.49984 9.16667C9.34079 9.16667 10.8332 7.67428 10.8332 5.83333C10.8332 3.99238 9.34079 2.5 7.49984 2.5C5.65889 2.5 4.1665 3.99238 4.1665 5.83333C4.1665 7.67428 5.65889 9.16667 7.49984 9.16667Z" stroke="#F79009" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M14.1665 6.66699L18.3332 10.8337" stroke="#F79009" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M18.3332 6.66699L14.1665 10.8337" stroke="#F79009" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </span>
                        <span className="txt-card">
                            <span className="count-card">
                                {count?.absent}
                            </span>
                            Absents
                        </span>
                    </div>
                    <div className="conf-card card-red">
                        <span className="icon-card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M4.10742 4.10742L15.8916 15.8924" stroke="#D93E3E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9.99984 18.3337C14.6022 18.3337 18.3332 14.6027 18.3332 10.0003C18.3332 5.39795 14.6022 1.66699 9.99984 1.66699C5.39746 1.66699 1.6665 5.39795 1.6665 10.0003C1.6665 14.6027 5.39746 18.3337 9.99984 18.3337Z" stroke="#D93E3E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </span>
                        <span className="txt-card">
                            <span className="count-card">
                                {conferenceParticipants?.filter(u => u.conference_status === 'bans').length}
                            </span>
                            Bannis
                        </span>
                    </div>
                </div>
                <div className="table-container">
                    <div className="table-header">
                        <h3>Inscrits externes <span className="all-guest">{filteredParticipants.length}</span></h3>

                        <div className="actions">
                            <span className="search-guest">
                                <input
                                    placeholder="Rechercher une personne"
                                    value={search}
                                    onChange={e => setSearch(e.target.value)}
                                />
                                <span class="material-symbols-outlined">
                                    search
                                </span>
                            </span>
                            <div className="btns-action">
                                <button className="btn export-xlsx" onClick={handleExportExcel} disabled={selectedExternalParticipent.length > 0 ? false : true}><img src={exelIcon} /> Exporter (.xlsx)</button>
                                <button className="btn green" onClick={handleRelance} disabled={selectedExternalParticipent.length > 0 ? false : true}>
                                    <span class="material-symbols-outlined">
                                        mail
                                    </span>
                                    Envoyer relance
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="wrap-table-conference">
                        <table>
                            <thead>
                                <tr>
                                    <th className="select-user">
                                        <input
                                            className="select-participent"
                                            type="checkbox"
                                            checked={selectAll}
                                            onChange={handleSelectAll}
                                        />
                                    </th>
                                    <th className="participants">Participants</th>
                                    <th className="row-email">Email</th>
                                    <th>Inscription</th>
                                    <th className="tstatus">Statut</th>
                                    <th>Accès</th>
                                    <th>Dernier mail</th>
                                    <th className="row-action"></th>
                                </tr>
                            </thead>

                            <tbody>
                                {filteredParticipants.map(p => (
                                    <tr key={p.user_id}>
                                        <td className="select-user">
                                            <input
                                                className="select-participent"
                                                type="checkbox"
                                                checked={selectedExternalParticipent.includes(p.user_id)}
                                                onChange={() => handleSelectOne(p.user_id)}
                                            />
                                        </td>
                                        <td className="participants">
                                            <div className="user">
                                                <div className="conf-avatar">
                                                    <img src={p.user.urlphoto} />
                                                </div>

                                                <div>
                                                    <div>{p.inscription_date ? (p.user.firstName + ' ' + p.user.lastName) : t('guest_externe')}</div>
                                                    {p.company && <small>{p.company}</small>}
                                                </div>
                                            </div>
                                        </td>

                                        <td className="row-email">{p.email}</td>
                                        <td>{p.inscription_date ? formatDate(p.inscription_date) : '-'}</td>

                                        <td className="tstatus">
                                            <span className={getStatusClass(p.conference_status)}>
                                                {t(p.conference_status)}
                                            </span>
                                        </td>

                                        <td>{p.access_type}</td>
                                        <td>{p.type_dernier_relance ? t(p.type_dernier_relance) : '-'}</td>
                                        <td className="row-action">
                                            <span class="material-symbols-outlined" onClick={(e) => handleOpenMenu(e, p.user_id)}>
                                                more_vert
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {menu.open && (
                <div
                    className="menu-participent-dropdown"
                    style={{
                        top: menu.y,
                        left: menu.x,
                        position: "fixed"
                    }}
                    onClick={(e) => e.stopPropagation()}
                >
                    {
                        filteredParticipants?.find(p => p.user_id === menu.userId)?.conference_status === 'awaiting_registration' &&
                        <div className="conf-dropdown-item" onClick={(e) => handleRelance(e, menu.userId)}>
                            <span class="material-symbols-outlined">
                                arrow_selector_tool
                            </span>
                            Renvoyer le lien
                        </div>
                    }
                    {
                        filteredParticipants?.find(p => p.user_id === menu.userId)?.access_type === 'room' &&
                        <div className="conf-dropdown-item" onClick={(e) => handleChangeAccess(e, menu.userId)}>
                            <span class="material-symbols-outlined">
                                language
                            </span>
                            Accorder accès map
                        </div>
                    }
                    {
                        filteredParticipants?.find(p => p.user_id === menu.userId)?.access_type !== 'room' &&
                        <div className="conf-dropdown-item" onClick={(e) => handleChangeAccess(e, menu.userId)}>
                            <span class="material-symbols-outlined">
                                meeting_room
                            </span>
                            Accorder accès room
                        </div>
                    }
                    {
                        filteredParticipants?.find(p => p.user_id === menu.userId)?.conference_status !== 'banni' &&
                        <div className="conf-dropdown-item danger" onClick={(e) => handleChangeStatus(e, menu.userId, 'banni')}>
                            <span class="material-symbols-outlined">
                                block
                            </span>
                            Bannir
                        </div>
                    }
                    {
                        filteredParticipants?.find(p => p.user_id === menu.userId)?.conference_status === 'banni' &&
                        <div className="conf-dropdown-item success" onClick={(e) => handleChangeStatus(e, menu.userId, 'no-banni')}>
                            <span class="material-symbols-outlined">
                                lock_open
                            </span>
                            Débannir
                        </div>
                    }
                </div>
            )}
        </>
    );
}